export interface BannerDismissInput {
  phase: string;
  accessState: string;
  severity: string;
  daysToExpiry: number;
  trialDaysLeft: number;
  daysSinceExpiry?: number | null;
  today?: Date;
}

/**
 * Clé de dismiss stable pour la bannière d'expiration : liée au CYCLE
 * d'abonnement (date d'expiration dérivée) et à la sévérité — pas au compteur
 * de jours. Un dismiss survit donc aux rechargements/sessions et ne se
 * réinitialise que si la sévérité monte ou qu'un nouveau cycle commence.
 */
export function expiryBannerDismissKey(input: BannerDismissInput): string {
  const today = input.today ?? new Date();
  const base = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));

  let offsetDays: number;
  if (input.phase === 'grace') {
    offsetDays = -(input.daysSinceExpiry ?? 0);
  } else if (input.accessState === 'trial_active') {
    offsetDays = input.trialDaysLeft;
  } else {
    offsetDays = input.daysToExpiry;
  }

  base.setUTCDate(base.getUTCDate() + offsetDays);
  const cycle = base.toISOString().slice(0, 10);

  return `${input.phase}:${input.accessState}:${cycle}:${input.severity}`;
}

export function readDismissed(storageKey: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function persistDismissed(storageKey: string, keys: string[]): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify(keys));
  } catch {
    // ignore
  }
}
